import { render, staticRenderFns } from "./SurveyModal.container.vue?vue&type=template&id=24605a13&"
import script from "./SurveyModal.container.vue?vue&type=script&lang=ts&"
export * from "./SurveyModal.container.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports